import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Autocomplete,
  Checkbox,
} from "@mui/material";
import { sendOtp } from "../../apiServices/services/CheckoutServices";
import { getcountries } from "../../apiServices/services/CompanyServices";
import BackButton from "../../assets/logo/BackButton.svg";
import RiseFormationsLogo from "../../assets/logo/riseformations-logo.webp";
import { countries } from "../../constants/countries";

const fieldLabelSx = {
  fontSize: "0.7rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  color: "#0F0049",
  marginBottom: "0.4rem",
};

const fieldSx = { backgroundColor: "#fff", borderRadius: "8px" };

const AccountCreationForm = ({ handleClickSetSeven, handlePrevious }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
  });

  const [countryCodes, setCountriesCode] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleCountryChange = (event, newValue) => {
    if (newValue) {
      setSelectedCountry(newValue);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    const { firstName, lastName, email, phoneNumber, password } = formData;
    if (!firstName || !lastName || !email || !phoneNumber || !password) {
      alert("Please fill all the details before proceeding forward.");
      return;
    }
    const data = {
      mobileNumber: selectedCountry.code + formData.phoneNumber,
      additionalDetails: "Some additional information if needed",
    };
    const formDatas = {
      ...formData,
      phoneNumber: selectedCountry.code + formData.phoneNumber,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "account_creation",
      userData: {
        name: formData.name,
        email: formData.email,
        timestamp: new Date().toISOString(),
      },
    });
    localStorage.setItem("registeredEmail", formData.email);
    sendOtp(data).then((res) => {
      if (res.status === 200) {
        console.log(res);
        handleClickSetSeven(formDatas);
      }
    });
  };

  useEffect(() => {
    const getcountries = async () => {
      // const response = await fetch("https://restcountries.com/v3.1/all");
      const allCountries = Array.isArray(countries)
        ? countries
        : Object.values(countries);

      const countryCodes = allCountries.map((country) => {
        const iddRoot = country?.idd?.root || ""; // Check if `idd.root` exists
        const iddSuffix = country?.idd?.suffixes?.[0] || ""; // Check if the first suffix exists

        return {
          label: country.name.common,
          code: iddRoot + iddSuffix, // Concatenate root and suffix safely
          flag: country.flags?.png || country.flags?.svg, // Use PNG or SVG flag image
        };
      });

      setCountriesCode(countryCodes);
      setSelectedCountry(countryCodes[47]); // Set the first country as default
    };

    getcountries();
  }, []);

  return (
    <Box
      id="account-creation-form"
      sx={{
        minHeight: "calc(100vh - 6rem)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          width: "100%",
          padding: { xs: "0.75rem 1rem", md: "1rem 2.5rem" },
        }}
      >
        <img
          src={RiseFormationsLogo}
          alt="Rise Formations"
          style={{ height: "1.75rem" }}
        />
      </Box>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "1rem", md: "2rem" },
        }}
      >
        <Box sx={{ width: "100%", maxWidth: "448px" }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "1.875rem",
                color: "#0F0049",
              }}
            >
              Create your account
            </Typography>

            <Typography
              sx={{
                fontSize: "0.875rem",
                color: "#82808A",
                marginTop: "0.5rem",
              }}
            >
              Set up your account to get started with your company
              incorporation.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Box sx={{ display: "flex", gap: "0.75rem", width: "100%" }}>
              <Box sx={{ flex: 1 }}>
                <Typography sx={fieldLabelSx}>First Name</Typography>
                <TextField
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  fullWidth
                  aria-label="First Name"
                  sx={fieldSx}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography sx={fieldLabelSx}>Last Name</Typography>
                <TextField
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  fullWidth
                  aria-label="Last Name"
                  sx={fieldSx}
                />
              </Box>
            </Box>

            <Box>
              <Typography sx={fieldLabelSx}>Email Address</Typography>
              <TextField
                name="email"
                value={formData.email}
                onChange={handleChange}
                variant="outlined"
                size="small"
                fullWidth
                type="email"
                aria-label="Email Address"
                sx={fieldSx}
              />
            </Box>

            <Box>
              <Typography sx={fieldLabelSx}>Create Password</Typography>
              <TextField
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                variant="outlined"
                size="small"
                fullWidth
                aria-label="Create Password"
                sx={fieldSx}
              />
            </Box>

            <Box sx={{ display: "flex", gap: "0.75rem", width: "100%" }}>
              <Box sx={{ flex: "0 0 33%" }}>
                <Typography sx={fieldLabelSx}>Code</Typography>
                <Autocomplete
                  options={countryCodes}
                  getOptionLabel={(option) =>
                    `${option.label} (${option.code})`
                  } // Label will not include the flag
                  value={selectedCountry}
                  onChange={handleCountryChange} // Update selected country on change
                  isOptionEqualToValue={(option, value) =>
                    option.code === value?.code
                  } // Prevent value mismatch
                  renderOption={(props, option) => (
                    <li {...props}>
                      <img
                        src={option.flag}
                        alt={option.label}
                        style={{ width: "20px", marginRight: "8px" }}
                      />
                      {option.label} ({option.code})
                    </li>
                  )}
                  sx={fieldSx}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" size="small" />
                  )}
                />
              </Box>

              <Box sx={{ flex: 1 }}>
                <Typography sx={fieldLabelSx}>Phone Number</Typography>
                <TextField
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  fullWidth
                  type="number"
                  aria-label="Phone Number"
                  sx={fieldSx}
                />
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", width: "100%", alignItems: "center", mt: 4 }}>
            <Button
              onClick={handlePrevious}
              sx={{
                color: "#000",
                fontSize: "1rem",
                textTransform: "none",
                marginRight: "1rem",
              }}
            >
              <img width={"70px"} src={BackButton} alt="Back" />
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              fullWidth
              sx={{
                backgroundColor: "#1f69f7",
                borderRadius: "8px",
                padding: "0.75rem 1rem",
                fontSize: "0.875rem",
                fontWeight: "600",
                textTransform: "none",
                ":hover": {
                  backgroundColor: "#1859c6",
                },
              }}
            >
              Create Account
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AccountCreationForm;
